import { jsx as _jsx } from "react/jsx-runtime";
import { GatewayClassName } from '@iotv/datamodel-core';
import NodeEdgeMapperListTable from '../../common/NodeEdgeMapperListTable';
const LinksTab = ({ mapper }) => {
    return mapper && _jsx(NodeEdgeMapperListTable, { mapper: mapper, excludeObjectTypeIds: [GatewayClassName], includeGroups: true });
};
export default LinksTab;
